/**
 * TagChip — pill-style label with colored dot.
 *
 * Mockup class: .tag with inner .tdot. Color comes from the tag record
 * (defined when the tag is created via TagPicker).
 */

interface TagChipProps {
  name: string;
  color: string; // CSS color value (hex or var())
}

export function TagChip({ name, color }: TagChipProps) {
  return (
    <span className="tag">
      <span className="tdot" style={{ background: color }} />
      {name}
    </span>
  );
}
